import { gql } from "@apollo/client";

export const InstalledBaseNodeFiles = gql`
    query InstalledBaseNodeFiles ($id: ID!) {
        installedBaseNode(id: $id) {
            id
            key
            title
            nodeType {
                id
                key
                name
            }
            access {
                id
                write
            }
            image {
                id
            }
            fileList {
                total
                installedBaseNodeFiles {
                    id
                    insert
                    filename
                    category
                    file {
                        id
                        basename
                        extension
                        contentType
                        size
                        link
                        thumbnailLink(crop: crop, w: 320, h: 320)
                        previewLink: thumbnailLink(w: 2560)
                        language
                    }
                    access {
                        id
                        read
                        write
                        delete
                    }
                    ... on InstalledBaseNodeFile {
                        id
                        comment
                    }
                }
            }
            assetLocation {
                id
                asset {
                    id
                    product {
                        id
                        fileList {
                            total
                            productNodeFiles {
                                id
                                insert
                                filename
                                category
                                file {
                                    id
                                    basename
                                    extension
                                    contentType
                                    size
                                    link
                                    thumbnailLink(crop: crop, w: 320, h: 320)
                                    previewLink: thumbnailLink(w: 2560)
                                    language
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
